import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FindRevenueExpenseProfitEntityQuery, RevenueStatisticApi } from 'api';

export interface RevenueStatisticTimeData {
  time: string;
  totalRevenue: number;
  totalExpense: number;
  totalProfit: number;
}

export interface RevenueStatisticValue {
  totalRevenue: number;
  totalExpense: number;
  totalProfit: number;
  statistic: Array<RevenueStatisticTimeData>;
}

export const findRevenueExpenseProfitEntity = createAsyncThunk(
  'revenueStatistic/findRevenueExpenseProfitEntity',
  async (option: FindRevenueExpenseProfitEntityQuery, { rejectWithValue }) => {
    try {
      const response = await RevenueStatisticApi.findRevenueExpenseProfitEntity(
        option
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  data: RevenueStatisticValue;
}

const initialState: IState = {
  data: { statistic: [], totalExpense: 0, totalProfit: 0, totalRevenue: 0 },
};

const revenueStatisticSlice = createSlice({
  name: 'revenueStatistic',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      findRevenueExpenseProfitEntity.fulfilled,
      (state, action) => {
        const { data } = action.payload;
        state.data = data;
      }
    );
  },
});

const { reducer: revenueStatisticReducer } = revenueStatisticSlice;

export default revenueStatisticReducer;
